var map = {
	"./arrow-mobile.svg": 8460,
	"./arrow.svg": 8486,
	"./prize-1.jpeg": 2276,
	"./prize-1.jpg": 7172,
	"./prize-2.jpeg": 5243,
	"./prize-2.jpg": 5248,
	"./prize-3.jpg": 8541,
	"./prize-3.png": 5634,
	"./prize-4.jpeg": 6456,
	"./prize-5.jpg": 8869,
	"./prize-thailand.png": 3888,
	"./prize-turkey.jpg": 8282,
	"./secretPrize.png": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7726;